import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message } from '@models/system';
import { type HttpService } from '@http/services';
import { IPAddress } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class IPAddressService implements HttpService<IPAddress> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<IPAddress[]>> {
        return this.http.get<IPAddress[]>(env.API_URL + '/ip-addresses', {
            params: qo.toObject(), // { offset: qo.offset, limit: qo.limit, eq: qo.eq, dig: qo.dig}, 
            observe: 'response'
        });
    }

    get(id: string) : Observable<HttpResponse<IPAddress>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    post(t: IPAddress): Observable<HttpResponse<IPAddress>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    put(t: IPAddress): Observable<HttpResponse<Message>> { 
        return throwError(() => new Error("Invalid API service call attempt"));
    }

    delete(id: string) : Observable<HttpResponse<Message>> {
        return throwError(() => new Error("Invalid API service call attempt"));
    }

}
